import React from 'react';
import PropTypes from 'prop-types';

import { getRelativeDateString, getAbsoluteDateString } from '../../lib/helpers';

function RelativeDatestamp({ date }) {
  const relativeDateString = getRelativeDateString(date);
  const absoluteDateString = getAbsoluteDateString(date);

  return (
    <div className='relative-datestamp'>
      <span title={absoluteDateString}>{relativeDateString}</span>
    </div>);
}

RelativeDatestamp.propTypes = {
  date: PropTypes.string,
};

RelativeDatestamp.defaultProps = {
  date: null,
};

export default RelativeDatestamp;



// WEBPACK FOOTER //
// ./src/views/Components/RelativeDatestamp.js